import React from 'react';
import { string, array, func } from 'prop-types';
import classnames from 'classnames';

import Dropdown from 'elements/Inputs/Dropdown';

import styles from './BillableId.css';

const BillableId = ({ title, opts, onChange }) => (
  <div className={styles.bilableMenu}>
    <div className={styles.separator} />
    <label className={classnames(styles.title, 'p small')}>{title}</label>

    <Dropdown
      opts={opts}
      onChange={onChange}
      customClasses={classnames(styles.dropdown, 'p large')}
      noEmptyState
    />
  </div>
);

BillableId.propTypes = {
  title: string.isRequired,
  opts: array.isRequired,
  onChange: func
};

BillableId.displayName = 'BillableId';

export default BillableId;



// WEBPACK FOOTER //
// ./src/uis/components/Header/BillableId/BillableId.js